export const configuratorUserEntryI18NPl = {
    you: "Ty",
};
